import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SynopticFile } from '../../../../model/synoptics/synoptic-file';
import { SVG } from '@svgdotjs/svg.js';

@Component({
  selector: 'app-synoptics-form-confirmation',
  templateUrl: './synoptics-form-confirmation.component.html',
  styleUrls: ['./synoptics-form-confirmation.component.scss']
})
export class SynopticsFormConfirmationComponent {

  @Input() synopticInfoForm: FormGroup;
  @Input() synopticFiles: SynopticFile[];
  @Input() mode: 'create' | 'edit';

  constructor() { }

}
